import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Tab from '../../../components/Tab';
import Menu from '../../../components/Menu';
import HasRole from '../../../components/HasRole';
import messages from '../messages';
import PremiumMenuItem from '../Edit/PremiumMenu/premiumMenuItem';

import * as constants from '../../Authorization/constants';
import '../styles.css';

const MediaMenu = ({
  onShowEditLogoModal,
  toggleUpgradeFormVisibility,
  onShowEditPhotosAndVideosModal,
}) => (
  <Tab.Pane attached={false}>
    <Menu vertical styleName="editor-menu">
      <HasRole anyOf={[constants.ADMIN_ROLE, constants.PUBLISHING_ROLE]}>
        <Menu.Item as="li" link styleName="editor-menu-item enabled" data-cy="Premium-Hem-Menu-Link-Logo" onClick={onShowEditLogoModal}>
          <FormattedMessage {...messages.logo} />
        </Menu.Item>
        <PremiumMenuItem
          onPremiumFeatureClick={toggleUpgradeFormVisibility}
          menuTitle={messages.photosAndVideosMenuItem}
          onClick={onShowEditPhotosAndVideosModal}
        />
      </HasRole>
    </Menu>
  </Tab.Pane>
);

MediaMenu.propTypes = {
  onShowEditLogoModal: PropTypes.func,
  toggleUpgradeFormVisibility: PropTypes.func,
  onShowEditPhotosAndVideosModal: PropTypes.func,
};

export default MediaMenu;
